import { createFileRoute } from '@tanstack/react-router';
import { PayrollReferenceCatalogRegistryPage } from './-components/PayrollReferenceCatalogRegistryPage';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/settings/payroll-reference-catalog/')({
  component: PayrollReferenceCatalogRegistryPage
});